var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"status"},[_c('div',{staticClass:"status-icon",class:{'is-loading': _vm.type === _vm.$constants.status.loading}},[(_vm.type === _vm.$constants.status.errored)?_c('i',{staticClass:"fa fa-exclamation-triangle"}):_vm._e()]),_c('div',{staticClass:"status-text"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }